import { render } from "./ColorGradient.vue?vue&type=template&id=29be4b70&scoped=true&ts=true"
import script from "./ColorGradient.vue?vue&type=script&lang=ts"
export * from "./ColorGradient.vue?vue&type=script&lang=ts"

import "./ColorGradient.vue?vue&type=style&index=0&id=29be4b70&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29be4b70"]])

export default __exports__